import { useState } from "react";
import { iniciais } from "./fotoUtil";

/** Foto da pessoa; sem foto, círculo laranja com as iniciais */
export default function Avatar({ nome, foto, tamanho = 38, className = "" }) {
  const [erro, setErro] = useState(false);
  const st = { width: tamanho, height: tamanho, minWidth: tamanho, fontSize: Math.round(tamanho * 0.38) };
  if (foto && !erro) {
    return <img src={foto} alt="" style={st} onError={() => setErro(true)} className={`rounded-full object-cover border-2 border-orange-500 ${className}`} />;
  }
  return (
    <span style={st} className={`rounded-full bg-orange-500 text-white font-bold flex items-center justify-center ${className}`}>
      {iniciais(nome)}
    </span>
  );
}
